import React from "react"
import styled from "styled-components"

export default styled(({ children, className, eyebrow, heading }) => (
  <div className={className}>
    <div className="icon">{children[0]}</div>
    <div className="eyebrow">{eyebrow}</div>
    <h3 className="heading">{heading}</h3>
    <p className="text">{children[1]}</p>
  </div>
))`
  background: white;
  text-align: center;
  max-width: 17.75rem;
  font-family: ${({ theme }) => theme.body};
  color: ${({ theme }) => theme.gray};
  line-height: 1.5rem;
  min-height: 23.4375rem;

  .icon {
    margin-top: 1.125rem;
    margin-bottom: 1.4375rem;
  }

  .eyebrow {
    text-transform: uppercase;
    margin-bottom: 0.25rem;
  }

  .heading {
    margin: 0;
    font-family: ${({ theme }) => theme.heading};
    font-size: 1.5rem;
  }

  .text {
    color: ${({ theme }) => theme.gray};
    margin-top: 1.1875rem;
    padding: 0 1.75rem 0.25rem;
    font-weight: 300;
  }

  @media (min-width: ${({ theme }) => theme.md}) {
    margin-top: 1rem;
    :nth-child(-n + 2) {
      margin-right: 1rem;
    }

    :first-child {
      margin-left: 1rem;
    }

    :last-child {
      margin-right: 1rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.md}) {
    margin-bottom: 1rem;
  }
`
